import { createElement, useContext, useLayoutEffect, useRef, } from "react";
import { AddGatewayContext, RemoveGatewayContext, } from "./GatewayProvider";
/**
 * Serves as portal destination for content of {@linkcode Gateway} with the same `name`
 *
 * Renders html elements
 * - child element as target for a react portal
 * - parent element as container for the child
 * @param props
 * @returns
 */
export function GatewayDest(props) {
    const { tag = "div", childTag = tag, style, childStyle, className, childClassName, } = props;
    // the child element must only be created once per destination
    // it is used by the React.createPortal function
    const childRef = useRef(document.createElement(childTag));
    // the parent element is rendered by react
    // we append the child element here
    const parentRef = useRef(null);
    const addGateway = useContext(AddGatewayContext);
    const removeGateway = useContext(RemoveGatewayContext);
    // needs to run after the parentRef is available
    useLayoutEffect(() => {
        const parent = parentRef.current;
        const child = childRef.current;
        // make available in Gateway Component
        addGateway(props.name, child);
        if (parent) {
            // renders parent into child
            parent.appendChild(child);
        }
        return () => {
            // make unavailable in Gateway component
            removeGateway(props.name);
            if (parent) {
                // and remove from parent
                parent.removeChild(child);
            }
        };
    }, [addGateway, removeGateway, props.name]);
    useLayoutEffect(() => {
        Object.assign(childRef.current.style, childStyle);
    }, [childStyle]);
    useLayoutEffect(() => {
        childRef.current.className = childClassName !== null && childClassName !== void 0 ? childClassName : "";
    }, [childClassName]);
    return createElement(tag, {
        style,
        className,
        ref: (el) => {
            parentRef.current = el;
        },
    });
}
//# sourceMappingURL=GatewayDest.js.map